import Param from "../../param";
import Util from '../libs/util';
import MainvisualBg from './mainvisual/bg';
import VisionBg from './mainvisual/visionBg';
import AboutBg from './mainvisual/aboutBg';

const param = new Param();
const util = new Util();

export default class MainvisualManager {
    constructor(w,h) {

        this.w = w;
        this.h = h;

        this.scene;
        this.camera;
        this.renderer;
        this.controls;

        this.mesh=[];
        this.uniforms=[];

        this.bg = [];
        this.visionBg = new VisionBg(w,h);
        this.aboutBg = new AboutBg(w,h);

        this.status = {
            current : 0,
            bgTimer : [],
            vision  : {
                timer : "",
            },
            about  : {
                timer : "",
            }
        }

        this.conf = {
            MAX : 4, /* 切り替えるセクションの数 */
        }

    }
    init(w,h,pixelRato) {

        let _this = this;

        // scene ステージ
        this.scene = new THREE.Scene();

        this.camera = new THREE.PerspectiveCamera(50, w / h, 1, 10000);
        this.camera.updateProjectionMatrix();
        this.camera.position.z = 1000;


        // this.controls = new THREE.OrbitControls(this.camera);
        // this.controls.autoRotate = true;

        this.renderer = new THREE.WebGLRenderer({
            alpha              : true,
            antialias          : false,
            failIfMajorPerformanceCaveat : false,
            stencil            : false,
            depth              : false,
        });
        this.renderer.setSize(w,h);
        this.renderer.setClearColor(0x000000,0);
        // this.renderer.setPixelRatio(pixelRato);
        this.renderer.setPixelRatio(1);



        for(let i=0; i<this.conf.MAX; i++){
            this.bg[i] = new MainvisualBg(w,h);
            this.bg[i].init(this.scene,param.webgl.mainvisual.scene[i].type,i);
        }

        setTimeout(()=>{
            this.visionBg.init(this.scene);
            this.aboutBg.init(this.scene);
            setTimeout(()=>{
                this.resize(this.w,this.h)
            },1e3);
        },1e3);


        document.getElementById('p-kv-bg').appendChild(this.renderer.domElement);
        // this.datGUI();


    }
    change(show,out){

        // this.status.current = show;

        this.status.current = show;

        clearTimeout(this.status.bgTimer[out]);
        if(show!==out) this.status.bgTimer[show] = setTimeout(()=>this.bg[show].show(param.webgl.mainvisual.scene[show].type,show),1e2);
        this.bg[out].out(param.webgl.mainvisual.scene[out].type,out);

        clearTimeout(this.status.vision.timer);
        if(show==1){
            this.status.vision.timer = setTimeout(()=> this.visionBg.show(),3e2)
        } else if(out==1){
            this.visionBg.out();
        }

        clearTimeout(this.status.about.timer);
        if(show==3){
            this.status.about.timer = setTimeout(()=> this.aboutBg.show(),1e3)
        } else if(out==3){
            this.aboutBg.out();
        }


    }
    playMovie(current,type){

        if(type==="play"){
            this.bg[current].outY(param.webgl.mainvisual.scene[current].type,current);
            if(current==1){
                this.visionBg.out();
            }

            if(current==3){
                this.aboutBg.out();
            }


        }else{

            if(current==1){
                setTimeout(()=> this.visionBg.show(),1e3)
            }
            if(current==3){
                setTimeout(()=> this.aboutBg.show(),1e3)
            }

            this.bg[current].showY(param.webgl.mainvisual.scene[current].type,current);
        }

    }
    productBgchange(current,texNo){
        this.bg[current].productChange(texNo);
    }
    render(mouse,time,fpsRate){

        // console.log(fpsRate);
        this.bg[this.status.current].render(mouse,time,fpsRate,param.webgl.mainvisual.scene[this.status.current].type,this.status.current);

        if(fpsRate>1.2||time%2===0) return;

        if(this.status.current==1) this.visionBg.render(mouse,time,fpsRate)
        if(this.status.current==3) this.aboutBg.render(mouse,time,fpsRate)
        this.renderer.render(this.scene, this.camera);

    }
    resize(w,h){

        this.w = w;
        this.h = h;

        // if(this.uniforms===undefined) return;
        // this.uniforms.resolution.value.x = w;
        // this.uniforms.resolution.value.y = h;

        if(this.camera===undefined) return;
        this.camera.aspect = w / h;
        this.camera.updateProjectionMatrix();
        this.camera.position.z = h / Math.tan(this.camera.fov * Math.PI / 360) / 2;


        for(let i=0; i<this.conf.MAX; i++){
            // console.log(i)
            this.bg[i].resize(w, h,param.webgl.mainvisual.scene[i].type,i);
        }

        this.visionBg.resize(w, h,this.status.current)
        this.aboutBg.resize(w, h,this.status.current)


        this.renderer.setSize(w, h);


    }
    datGUI(){

        let _this = this;

        let _gui = new dat.gui.GUI();

        // _gui.remember();
        // //

        // var _f1 = _gui.addFolder('Transition');
        //
        // let _easing = _f1.add(this.bg[0].conf, 'ease', [
        //     "Power3.easeInOut",
        //     "Expo.easeInOut",
        //     "SlowMo.ease.config(0.1, 0.4, false)",
        //     "SlowMo.ease.config(0.3, 0.7, false)",
        //     "SlowMo.ease.config(0.7, 0.7, false)",
        //     "SlowMo.ease.config(0.4, 0.8, false)",
        // ]);
        // let _speed = _f1.add(this.bg[0].conf, 'speed', 0.00, 2.00);
        //
        //
        // _easing.onChange(function(value) {
        //
        //     for(let i=0; i<_this.conf.MAX; i++){
        //         _this.bg[i].conf.ease = value;
        //
        //     }
        //
        //
        // });
        // _speed.onChange(function(value) {
        //
        //     for(let i=0; i<_this.conf.MAX; i++){
        //         _this.bg[i].conf.speed = value;
        //
        //     }
        //
        //
        // });

        var _f1 = _gui.addFolder('Mainvisual Opacity');
        let _opacity = _f1.add(this.bg[0].video[0].uniforms.opacity, 'value', 0.00, 1.00);





    }

}